import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { BasicItemResult } from '../../models/interfaces/basic-item-result.interface'
import { BasicNotificationsResult, NotificiationNameEnum } from '../../models/interfaces/basic-notifications.interface'
import { CRMOrganization } from '../../models/interfaces/crm-organization.interface'
import { User } from '../../models/interfaces/user.interface'

export const setUser = createAction('[stage] Setting user', props<{ user: User }>())

export const searchCRMOrganizationList = createAction('[stage] Search CRM Organization List', props<{ query: string }>())

export const searchCRMOrganizationListSuccess = createAction('[stage] Search CRM Organization List Success', props<{ response: CRMOrganization[] }>())

export const searchCRMOrganizationListFailure = createAction('[stage] Search CRM Organization List Failure', props<{ error: HttpErrorResponse }>())

export const cleanCRMOrganizations = createAction('[stage] Clean CRM Organizations')

export const setSectors = createAction('[stage] Setting sectors')

export const setSectorsSuccess = createAction('[stage] Setting sectors SUCCESS', props<{ sectors: BasicItemResult[] }>())

export const setSectorsFailure = createAction('[stage] Setting sectors FAILURE', props<{ error: HttpErrorResponse }>())

export const setSoughtPartnerCountries = createAction('[stage] Setting sought partner countries')

export const setSoughtPartnerCountriesSuccess = createAction(
   '[stage] Setting sought partner countries SUCCESS',
   props<{ soughtPartnerCountries: BasicItemResult[] }>()
)

export const setSoughtPartnerCountriesFailure = createAction('[stage] Setting sought partner countries FAILURE', props<{ error: HttpErrorResponse }>())

export const getPNOUserNotifications = createAction('[stage] Getting PNO user notifications')

export const getPNOUserNotificationsSuccess = createAction(
   '[stage] Getting PNO user notifications SUCCESS',
   props<{ userNotifications: BasicNotificationsResult }>()
)

export const getPNOUserNotificationsFailure = createAction('[stage] Getting PNO user notifications FAILURE', props<{ error: HttpErrorResponse }>())

export const updatePNOUserNotifications = createAction(
   '[stage] Updating PNO user notifications',
   props<{ notificationName: NotificiationNameEnum; isActive: boolean }>()
)

export const updatePNOUserNotificationsSuccess = createAction('[stage] Updating PNO user notifications SUCCESS')

export const updatePNOUserNotificationsFailure = createAction('[stage] Updating PNO user notifications FAILURE', props<{ error: HttpErrorResponse }>())

export const cleanNotifications = createAction('[stage] Cleaning notifications')
